<template>
  <v-row justify="center" align="center">
    <v-col cols="12" lg="6" sm="6">
      <v-card class="mt-3">
        <v-card-title>
          {{ $t("analytics.general.Location.title") }} :
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <td style="max-width: 50px">
                {{ $t("analytics.general.Location.Country") }}
              </td>
              <td>{{ $t("analytics.general.Location.Number_user") }}</td>
              <td>{{ $t("analytics.general.Location.Pecentage") }}</td>
            </thead>
            <tbody v-if="locations && locations.length">
              <tr
                v-for="(item, i) in locations"
                :key="i"
                :class="hover === i ? 'hover' : ''"
              >
                <td style="max-width: 50px">
                  <country-flag
                    :country="item.location_country"
                    size="normal"
                    rounded
                    class="elevation-6"
                  />
                </td>
                <td>{{ item.number_user }}</td>
                <td>{{ (item.pourcentage * 100).toFixed(2) }}%</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td style="max-width: 50px">-</td>
                <td>-</td>
                <td>-</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" lg="5" sm="6">
      <WorldMapVue
        :country-data="CountryData"
        :show-overlay="showMapOverlay"
        @mouseenter="onMouseEnterMapCountry"
        @mouseleave="onMouseLeaveMapCountry"
      >
        <template v-slot:overlay>
          <v-row justify="center" align="center">
            <v-col class="mt-2" cols="7">
              <v-list-item class="ma-0 pa-0">
                <v-list-item-content class="pt-0">
                  <v-list-item-subtitle>
                    {{ $t("analytics.general.Location.Country") }} :
                    {{ selected_contry.location_country.toUpperCase() }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ $t("analytics.general.Location.Number_user") }} :
                    {{ selected_contry.number_user }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ $t("analytics.general.Location.Pecentage") }} :
                    {{ (selected_contry.pourcentage * 100).toFixed(2) }}%
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="auto">
              <country-flag
                :country="selected_contry.location_country"
                size="big"
                rounded
                class="elevation-2"
              />
            </v-col>
          </v-row>
        </template>
      </WorldMapVue>
    </v-col>
  </v-row>
</template>

<script>
import CountryFlag from "vue-country-flag";
import WorldMapVue from "world-map-vue";

export default {
  name: "ProfilUtilisation",
  components: {
    CountryFlag,
    WorldMapVue,
  },
  computed: {
    locations() {
      const data = this.$store.state.analytics.ProfilUtilisation.data;
      return data;
    },
    CountryData() {
      const data = this.$store.state.analytics.ProfilUtilisation.CountryData;
      return data;
    },
  },
  data() {
    return {
      showMapOverlay: false,
      selected_contry: undefined,
      hover: undefined,
    };
  },
  methods: {
    onMouseEnterMapCountry(countryCode) {
      if (this.locations && this.locations.length) {
        const index = this.locations.findIndex((r) => {
          return r.location_country.toUpperCase() === countryCode;
        });
        if (index >= 0) {
          this.showMapOverlay = true;
          this.selected_contry = this.locations[index];
          this.hover = index;
        } else {
          this.showMapOverlay = false;
          this.selected_contry = undefined;
          this.hover = undefined;
        }
        // Update your data/property to be displayed on the overlay.
      }
    },
    onMouseLeaveMapCountry() {
      this.showMapOverlay = false;
      this.selected_contry = undefined;
      this.hover = undefined;
    },
    // onClickMapCountry(data) {
    //   console.log("Click Country", data);
    // },
  },
};
</script>

<style scoped>
.icon-card {
  position: absolute;
}
.hover {
  background: #eeeeee;
}
</style>
